export default {
	useYnList: [],
	ckuScnList: [], //검사구분코드
	ckuPartScnList: [], //검사부품구분
	sttsPartList: [], //현황부품구분
	resultList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		partNo: '',
		partNm: '',
		cpnyCd: '',
		useYn: 'Y'
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
